import { gql } from '@apollo/client';

export const SET_TRACK_HAS_NO_ADVERSE_EVENTS = gql`
  mutation SetTrackHasNoAdverseEvents($trackId: IdentifierType!, $hasNoAdverseEvents: Boolean!) {
    setTrackHasNoAdverseEvents(trackId: $trackId, hasNoAdverseEvents: $hasNoAdverseEvents) {
      ok
    }
  }
`;
